import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseUpdateMutation, IUpdateFn, ITrainingPersonRequirementUpdateUpsert, ITrainingPersonRequirement, IGetPatchRequest } from '../../interfaces'

const getUpdateTrainingPersonRequirementMutationRequest: IGetPatchRequest = params => {

  return {
    method: 'patch',
    url: `${config.baseUrl}/PersonTrainingRequirements/`,
  }
}

const useUpdateTrainingPersonRequirementMutation: IUseUpdateMutation<ITrainingPersonRequirement, ITrainingPersonRequirementUpdateUpsert> = (params, options = {}) => {
  const request = useMemo(() => getUpdateTrainingPersonRequirementMutationRequest(params), [params])

  const updateTraining: IUpdateFn<ITrainingPersonRequirementUpdateUpsert, ITrainingPersonRequirement> = useCallback(
    async data => {
      return axios({ ...request, url: request.url + data.id + '/dates', data }).then(res => res.data)
    },
    [request],
  )

  const response = useMutation<ITrainingPersonRequirement, Error, any>({
    mutationFn: updateTraining,
    ...options,
  })

  return response
}

export default useUpdateTrainingPersonRequirementMutation
